import { getBaseUrl } from "../../../config/runtimeConfig";

export const getImageUri = (): string => {
  return `${getBaseUrl()}/file?path=`;
};
